import { AlignmentType, Paragraph, TextRun, TableCell, Table, BorderStyle, TableRow, WidthType, ShadingType, TextDirection } from 'docx'
export const graphText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 600 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical representation of Identified Vulnerabilities to Severity Risk rating",
            size: 24,
            font: "Calibri",
            color: 'C00000',
            bold: true,
            italics: false
        }),
    ],
})


export const tableText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Table: Representing Severity Level",
            size: 24,
            font: "Calibri",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})

export function severityLevelTable(certInHigh, certInMedium, certInLow) {
    return new Table({
        width: { size: 55, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 1200 },
        borders: {
            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
        },

        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 13, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        indent: { left: 800 },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),

                    new TableCell({
                        width: { size: 59, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Severity Level",
                                        font: "Calibri",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),

                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Frequency",
                                        font: "Calibri",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),
                ]
            }),
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "High",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(certInHigh),
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "2",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Medium",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(certInMedium),
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "3",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Low",
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(certInLow),
                                        font: "Calibri",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),


        ]
    })
}



export const graphText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 650, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical Representation of Identified Gaps",
            size: 24,
            font: "Calibri",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})